/**
 * MetalVision Kiosko - App Principal
 */

import { initAuth, redirectToPanelIfNeeded } from './auth.js';
import { getDisplayType } from './modules/device-auth.js';

// Inicializar aplicación
async function init() {
  console.log('🚀 Iniciando MetalVision Kiosko...');

  // Autenticar dispositivo
  const authSuccess = await initAuth();

  if (!authSuccess) {
    console.log('❌ Autenticación fallida');
    return;
  }

  // Dispositivo tipo 'panel': esta app solo hace de portero hacia el tablero.
  if (await redirectToPanelIfNeeded()) {
    console.log('📺 Dispositivo tipo panel: redirigiendo al tablero');
    return;
  }

  // Reveal app content only after successful authentication
  document.getElementById('app')?.classList.remove('auth-pending');

  // Tablet del responsable de taller: va directa al avance para marcar fases, sin menú.
  if (getDisplayType() === 'tablet_taller') {
    const home = document.getElementById('avance-home');
    if (home) home.style.display = 'none';
    await window.navigateTo('avance');
  }
  
  console.log('✅ Autenticación exitosa');
  console.log('✅ Kiosko listo');
}

// Iniciar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
